import { supabase, isSupabaseConfigured } from "./supabaseClient";

const LOCAL_KEY = "vrfood_settings_v1";
const isBrowser = typeof window !== "undefined";

export const DEFAULT_SETTINGS = {
  address:
    "Factory: 624, Navghar Road, Near Water Tank, At. Post Saphale (E) Tal./Dist. Palghar-401 102. Maharashtra (India)",
  email: "vrfood74@gmail.com",
  footerPhone: "+91 98921 61748",
  contactPhone: "+91-85917 63320, 76662 24054",
  gstin: "27AYVPR4504K1ZQ",
  pan: "AYVPR4504K",
  state: "Maharashtra (Code: 27)",
  placeOfSupply: "Maharashtra",
  licenseNo: "11516023000110",
  instagramUrl: "https://www.instagram.com/vr_foodproducts/profilecard/?igsh=dnQwbmRwNmIwbW5q",
  linkedinUrl:
    "https://www.linkedin.com/in/vr-food-products-995704339?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15037.459958086918!2d72.8364083!3d19.5688578!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7078e16964c25%3A0x11d958c6678e3320!2sVR%20FOODS!5e0!3m2!1sen!2sin!4v1731840179078!5m2!1sen!2sin",
};

function readLocal() {
  if (!isBrowser) return DEFAULT_SETTINGS;
  const raw = window.localStorage.getItem(LOCAL_KEY);
  if (!raw) return DEFAULT_SETTINGS;
  try {
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

const localAdapter = {
  async getSettings() {
    return readLocal();
  },
  async updateSettings(patch) {
    const updated = { ...readLocal(), ...patch };
    if (isBrowser) window.localStorage.setItem(LOCAL_KEY, JSON.stringify(updated));
    return updated;
  },
};

// Only Google's own maps embed domain is allowed in the iframe src — this
// field is admin-only, but the value still ends up in a public page's
// iframe, so it's worth constraining server + client side.
function isSafeMapEmbedUrl(url) {
  if (!url) return true;
  try {
    const { protocol, hostname } = new URL(url);
    return protocol === "https:" && hostname === "www.google.com";
  } catch {
    return false;
  }
}

const ROW_ID = "main";

const supabaseAdapter = {
  async getSettings() {
    const { data, error } = await supabase
      .from("site_settings")
      .select("*")
      .eq("id", ROW_ID)
      .maybeSingle();
    if (error) throw error;
    return data ? { ...DEFAULT_SETTINGS, ...data } : DEFAULT_SETTINGS;
  },
  async updateSettings(patch) {
    if (!isSafeMapEmbedUrl(patch.mapEmbedUrl)) {
      throw new Error("Map embed URL must be a https://www.google.com link.");
    }
    const { data, error } = await supabase
      .from("site_settings")
      .upsert({ id: ROW_ID, ...patch })
      .select()
      .single();
    if (error) throw error;
    return data;
  },
};

const adapter = isSupabaseConfigured ? supabaseAdapter : localAdapter;

export const { getSettings, updateSettings } = adapter;
